import React from 'react'
import { Link } from 'gatsby'

const AimBlogPagination = ({ baseUrl, current, last }) => {
  const first = 1
  // 最初と最後を除いたページ表示数
  const size = 5
  // 両端のDotで挟まれた数列の中央値番号
  const medianNumber = (size + 1) / 2
  // 両端にDotが現れる最小のページ番号
  const minDotNumber = first + Math.floor(medianNumber) + 1
  // 両端にDotが現れる最大のページ番号
  const maxDotNumber = last - Math.ceil(medianNumber) - 1
  // 左側Dotの右隣のページ番号
  const startDotNumber = current - Math.floor(medianNumber) + 1
  // 指定した数字から始まる連番配列
  const range = (startNumber, rangeSize) => [...Array(rangeSize)].map((_, i) => startNumber + i)

  return (
    <ul className="aimBlogPagination">
      {/* last < first + size + 3のとき両端Dot表示ができないので全て表示 */}
      {last < first + size + 3 ? (
        range(first, last).map((number) => (
          <li className={`aimBlogPagination__li ${number !== current ? '' : 'aimBlogPagination__li--active'}`} key={number}>
            <Link to={number !== first ? `${baseUrl}/${number}` : `${baseUrl}`}>{number}</Link>
          </li>
        ))
      ) : (
        <>
          {/* 最初のページ */}
          <li className={`aimBlogPagination__li ${current !== first ? '' : 'aimBlogPagination__li--active'}`}>
            <Link to={baseUrl}>{first}</Link>
          </li>

          {/* 左側のDot */}
          {current >= minDotNumber && <li className="aimBlogPagination__li aimBlogPagination__li--dot">...</li>}

          {/* Aパターン(右側のみDotがある) */}
          {current < minDotNumber &&
            range(first + 1, size).map((number) => (
              <li className={`aimBlogPagination__li ${number !== current ? '' : 'aimBlogPagination__li--active'}`} key={number}>
                <Link to={`${baseUrl}/${number}`}>{number}</Link>
              </li>
            ))}

          {/* Bパターン(両端にDotがある) */}
          {current >= minDotNumber &&
            current <= maxDotNumber &&
            range(startDotNumber, size).map((number) => (
              <li className={`aimBlogPagination__li ${number !== current ? '' : 'aimBlogPagination__li--active'}`} key={number}>
                <Link to={`${baseUrl}/${number}`}>{number}</Link>
              </li>
            ))}

          {/* Cパターン(左側のみDotがある) */}
          {current > maxDotNumber &&
            range(last - size, size).map((number) => (
              <li className={`aimBlogPagination__li ${number !== current ? '' : 'aimBlogPagination__li--active'}`} key={number}>
                <Link to={`${baseUrl}/${number}`}>{number}</Link>
              </li>
            ))}

          {/* 右側のDot */}
          {current <= maxDotNumber && <li className="aimBlogPagination__li aimBlogPagination__li--dot">...</li>}

          {/* 最後のページ */}
          <li className={`aimBlogPagination__li ${current !== last ? '' : 'aimBlogPagination__li--active'}`}>
            <Link to={`${baseUrl}/${last}`}>{last}</Link>
          </li>
        </>
      )}
    </ul>
  )
}
export default AimBlogPagination
